/* eslint-disable */
export default {
    'checkout.back': 'Volver',
    'checkout.steps.info': 'Información',
    'checkout.steps.payment': 'Pago',
    'checkout.steps.done': 'Confirmación',

    'common.close': 'Cerrar X',

    'widget.vacancies': '¡{n} lugares disponibles!',
    'widget.vacanciesTooltip': 'Este es el número de personas que aún pueden participar en este evento',
    'widget.event': 'Evento:',
    'widget.eventClosed': 'Privado',
    'widget.scheduledBy': 'Agendado por:',
    'widget.contact': 'Contacto:',
    'widget.choosePackage': 'Elige tu entrada',
    'widget.available': 'disponible',
    'widget.noTickets': 'No hay tipos de entrada disponibles. Contáctanos para continuar.',
    'widget.continue': 'CONTINUAR',
    'widget.disagree': '¿Hay alguna información aquí con la que no estés de acuerdo?',
    'widget.reportProblem': 'Informar un problema',
    'widget.easyCancellation': 'Cancelación Fácil',
    'widget.dataSecurity': 'Seguridad de datos',
    'widget.cancelRules': 'Política de cancelación',
    'widget.chooseDate': 'Elige la fecha:',
    'widget.chooseHour': 'Elige la hora:',
    'widget.today': 'Hoy',
    'widget.select': 'SELECCIONA',
    'widget.noDates': 'Lamentablemente no hay fechas disponibles para reservar en línea. Contáctanos para saber más.',
    'widget.insertData': 'Ingresa tus datos:',
    'widget.freeScheduling': 'No necesitas pagar para agendar',
    'widget.shareInvite': 'Invita a tus amigos compartiendo este enlace con los datos de la reserva:',
    'widget.reserved': '¡Tu horario está reservado!',
    'widget.copy': 'Copiar',
    'widget.reserveHour': 'Reservar horario',
    'widget.unavailable': 'No disponible',
    'widget.hourStillAvailable': 'Horario aún disponible',
    'widget.reserve': 'Reservar',
    'widget.spots': 'lugares',

    'auth.facebook': 'INICIAR SESIÓN CON FACEBOOK',
    'auth.or': 'o',
    'auth.name': 'Nombre',
    'auth.email': 'Email',
    'auth.phone': 'Teléfono',
    'auth.password': 'Contraseña',
    'auth.signupButton': 'REGÍSTRATE',
    'auth.signinButton': 'ENTRAR',
    'auth.signin': 'Entrar',
    'auth.signup': 'Regístrate',
    'auth.forgot': 'Olvidé mi contraseña',
    'auth.send': 'Enviar',
    'auth.loggedIn': 'Sesión iniciada con éxito',
    'auth.facebookError': 'Error al intentar acceder con Facebook.',
    'auth.forgotSent': '¡Te enviamos un email con tu nueva contraseña!',
    'validation.requiredField': '"{field}" no puede estar vacío.',
    'validation.invalidField': '"{field}" inválido.',

    'checkout.info.title': 'Información',
    'checkout.info.selectParticipant': 'Selecciona un participante para completar sus datos:',
    'checkout.info.fillParticipant': 'Completa los datos del participante:',
    'checkout.info.participant': 'Participante {n}',
    'checkout.info.fullName': 'Nombre completo*',
    'checkout.info.nameRequired': 'El nombre es obligatorio',
    'checkout.info.email': 'Email*',
    'checkout.info.emailInvalid': 'Email inválido',
    'checkout.info.cellPhone': 'Teléfono móvil*',
    'checkout.info.observation': 'Observaciones',
    'checkout.info.observationHint': '(Ej.: atención especial, código promocional, etc.)',
    'checkout.info.privacyAgree': 'Estoy de acuerdo con la {link}',
    'checkout.info.privacyPolicy': 'Política de privacidad de datos',
    'checkout.continue': 'Continuar',
    'checkout.next': 'Siguiente',

    'payment.title': 'Pago',
    'payment.choose': 'Elige tu forma de pago:',
    'payment.discount.title': 'Descuento',
    'payment.discount.question': '¿Tienes un cupón de descuento? Aplícalo aquí:',
    'payment.discount.placeholder': 'Cupón de descuento',
    'payment.discount.apply': 'Aplicar',
    'payment.discount.remove': 'Quitar',
    'payment.discount.added': '¡Cupón aplicado con éxito!',
    'payment.discount.removed': '¡Cupón eliminado con éxito!',
    'payment.discount.invalid': '¡Cupón inválido!',
    'payment.confirmAndPay': 'CONFIRMAR Y PAGAR',
    'payment.reserve': 'RESERVAR',
    'payment.redirectInfo': 'Al confirmar, serás dirigido a la página segura de {gateway} para completar el pago y luego volverás aquí.',
    'payment.creditCardBrazilOnly': 'El pago con tarjeta de crédito solo acepta tarjetas emitidas en Brasil. Si tu tarjeta es internacional, utiliza PayPal.',

    'phone.label': 'Teléfono',
    'phone.intlHint': 'ej.: +34 612 345 678',
    'validation.phoneInvalid': 'Número de teléfono inválido',
};
